import React, { Component } from 'react';
import { Modal, Toast } from 'antd-mobile'
import { req_findMyRecord, req_findTeacherRecord, req_createUrl } from './../../api/api'
import './index.css'
import moment from 'moment'
import cookie from 'react-cookies'
import IP from './../../config/config'

export default class componentName extends Component {
  state = {
    data: [],
    url: '',
    visible: false,
  }

  componentDidMount = () => {
    this.fetch()
  }

  // 合成分享链接
  createUrl = async () => {
    const res = await req_createUrl()
    if (res.code === 20000) {
      this.setState({
        url: IP.wxredirect + '/?record_id=' + res.data
      })
    }

  }

  fetch = async () => {
    const method = cookie.load('type') == 'app' ? req_findTeacherRecord : req_findMyRecord
    const res = await method({ teacherCode: cookie.load('teacher_code') })
    if (res.code === 20000) {
      this.setState({
        data: res.data
      })
    }
  }

  copy = () => {
    //一键复制功能
    const copyEle = document.querySelector('.contentText') // 获取要复制的节点
    const range = document.createRange(); // 创造range
    window.getSelection().removeAllRanges(); //清除页面中已有的selection
    range.selectNode(copyEle); // 选中需要复制的节点
    window.getSelection().addRange(range); // 执行选中元素
    const copyStatus = document.execCommand("Copy"); // 执行copy操作
    // 对成功与否定进行提示
    if (copyStatus) {
      Toast.success("复制成功，请粘贴到微信进行分享！", 3)
    } else {
      Toast.error("复制失败!")
    }
    window.getSelection().removeAllRanges(); //清除页面中已有的selection
  }

  render() {
    const { data, url, visible } = this.state
    return (
      <div className="record">
        <div className="record-body">
          <div className="record-list" style={{ paddingBottom: cookie.load('type') == 'app' ? '68px' : '0px' }}>
            {
              data.map(val => {
                return (
                  <div className="record-item" key={val.record_id} onClick={() => {
                    this.props.history.push(`/details/${val.record_id}`)
                  }}>
                    <div className="record-item-head">
                      <div>{val.teacher_name}</div>
                      <div>
                        <span>访客{val.visitor_num}人</span> | 
                        {
                          val.status === 1 ? <span className='record-item-head-wait'> 待审核</span> :
                          val.status === 2 ? <span className='record-item-head-success'> 审核通过</span> : 
                          val.status === 3 ? <span className='record-item-head-error'> 审核不通过</span> :
                          val.status === 4 ? <span className='record-item-head-wait'> 已失效</span> : ''
                        }
                      </div>
                    </div>
                    <div className="record-item-foot">
                      <div>{val.type_name}&nbsp;|&nbsp;{val.dep_name && val.dep_name.length > 8 ? val.dep_name.substr(0, 8) + '...' : val.dep_name}</div>
                      <div>{moment(val.create_time).format('YYYY/MM/DD HH:mm')}</div>
                    </div>
                  </div>
                )
              })
            }
            {
              data.length === 0 ? <div style={{ textAlign: 'center', color: '#dfdfdf', background: '#f5f5f5', paddingTop: '10px' }}>--暂无数据--</div> : ''
            }
          </div>
        </div>
        {/* {
          cookie.load('type') ? (<div className="details-but" style={{ background: 'none' }}>
            <div onClick={() => {
              this.setState({
                visible: true
              })
              if (cookie.load('code') != 'null') {
                this.createUrl()
              }
            }}>分享链接</div>
          </div>) : ''
        } */}

        <Modal
          transparent
          visible={visible}
          onClose={() => {
            this.setState({
              visible: false
            })
          }}
          animationType="slide-up"
        >
          <div className="contentText record-modal-url">{url}</div>
          <div className="record-modal-click" onClick={() => {
            this.copy()
          }}>复制链接</div>
        </Modal>
      </div>
    );
  }
}
